import { useState } from 'react';

import { Button } from '../../../../cdl/Button/Button';
import { translate } from '../../../../common/helpers/translate.helper';
import { IconTransfer } from '../../../../common/icons/cdl/Transfer';

import { VesselDataMigrationModal } from './VesselDataMigrationModal';

export const VesselDataMigrationButton = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return (
        <>
            <Button onClick={() => setIsModalOpen(true)} LeadingIcon={IconTransfer}>
                {translate('vessel.migration.button')}
            </Button>
            {isModalOpen ? <VesselDataMigrationModal onDismiss={() => setIsModalOpen(false)} /> : null}
        </>
    );
};
